export const LOGO_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_merchant-offers-7/artifacts/ifrxupqh_pmi%20logo.jpg";
export const POSTCARD_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_merchant-offers-7/artifacts/f6c8aa9r_pmi%20card%20v3.jpg";
